import React, {useState} from 'react';
import {messageBoxError, messageBoxSuccess} from '@deviceinsight/ng-ui-components';
import {Button} from '@deviceinsight/ng-ui-basic-components';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {updateCustomDatapoint} from '../../api/customDatapointsApi';
import {CustomDatapoint} from '../../modules/customDatapoints/types';
import {Asset} from '@deviceinsight/ng-ui-api-client';

type Props = {
	disabled: boolean;
	dp: CustomDatapoint;
	asset: Asset;
	refresh: () => void;
};

const ValueColumnInputComponent = ({disabled, dp, asset, refresh}: Props) => {
	const [isDirty, setDirty] = useState<boolean>(false);
	const [editedValue, setEditedValue] = useState<number>(dp.value);

	const updateValue = () => {
		const customDpObj = {
			id: dp.id,
			name: dp.name,
			value: editedValue
		};

		updateCustomDatapoint(asset.urn, dp.id, customDpObj)
			.then(() => {
				messageBoxSuccess(
					<Trans i18nKey="customDatapoints.updateValue.updateValueSuccess">Value updated</Trans>
				);
				refresh();
			})
			.catch(() =>
				messageBoxError(
					<Trans i18nKey="customDatapoints.updateValue.updateValueError">Value was not updated!</Trans>
				)
			)
			.finally(() => setDirty(false));
	};

	const cancel = () => {
		setEditedValue(dp.value);
		setDirty(false);
	};

	return (
		<span className="di field">
			<input
				style={{border: 0, width: 200, marginRight: 10}}
				size={40}
				maxLength={40}
				type="number"
				disabled={disabled}
				data-testid={`value-${dp.value}`}
				placeholder=""
				value={editedValue}
				onChange={(e) => {
					setDirty(true);
					setEditedValue(parseFloat(e.target.value));
				}}
			/>
			{isDirty && (
				<>
					<Button primary data-testid={`updateValueButton-${dp.value}`} onClick={updateValue}>
						<Trans i18nKey="general.actions.save">Save</Trans>
					</Button>
					<Button onClick={cancel}>
						<Trans i18nKey="general.actions.cancel">Cancel</Trans>
					</Button>
				</>
			)}
		</span>
	);
};

export default ValueColumnInputComponent;
